import './App.css';
import Header from './components/header/header';
import Home from './components/home/home';
import About from './components/about/about';
import Skills from './components/skills/skills';
//import Services from './components/services/services';
import Qualification from './components/qualifications/qualification';
import Certificates from './components/certificates/certificates';
import Contact from './components/contact/contact';
import Footer from './components/footer/footer';
import ScrollUp from './components/scrollup/scrollup';
import ProjectList from './components/projects/projects';
import ProfesionnalList from './components/Professional/projects';
import Calmini from './components/projects/calmini'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import RedRadio from './components/projects/redRadio';
import Boutellis from './components/projects/boutellis';
import AeroLink from './components/projects/Aerolink';
import AgroSmart from './components/projects/AgroSmart';
import EduSmart from './components/projects/EduSmart';
import EduFlex from './components/projects/EduFlex';
import ScrollToTop from './components/projects/scrollToTop/scrollToTop';
import Achievements from './components/achievements/achievements';
import HackAtlas from './components/achievements/hackAtlas';
import HackMinds from './components/achievements/hackMinds';
import HackEsprit from './components/achievements/hackEsprit';
import SinistrIA from './components/Professional/SinistrIA.jsx';
import Yopex from './components/Professional/Yopex.jsx';
import Khadamet from './components/Professional/Khadamet.jsx';
import RNEBot from './components/Professional/RNEBot.jsx';
import NeoTm from './components/Professional/NeoTm.jsx';
import VisioWave from './components/Professional/VisioWave.jsx';  
import IEEE from './components/achievements/IEEE.jsx';
import Massai from './components/achievements/Massai.jsx';
import ExpressFM from './components/achievements/ExpressFM.jsx';
import RadioIFM from './components/achievements/Radio_IFM.jsx';
import LinearRegression from './components/achievements/Workshop.jsx';
import Samsung from './components/achievements/Samsung.jsx';
import TuniHack from './components/achievements/TuniHack.jsx';
import SMUHack from './components/achievements/SMU.jsx';
import Hack4Justice from './components/achievements/Hack4Justice.jsx';
import HackFlow from './components/achievements/AIhackflow.jsx';

function App() {
  return (
    <>
    <BrowserRouter>
      <Header/>
      <ScrollToTop/>
      <Routes>
        <Route exact path="/" element={

          <>
         
          <Home/>
          <About/>
          <Skills/>
          <Qualification/>
          <ProfesionnalList/>
          <ProjectList/>
          <Achievements/>
          <Certificates/>
          <Contact/>
         
          </>

          }/>

          <Route path="/RedRadio" element={<RedRadio />} />
          <Route path="/Calmini" element={<Calmini />} />
          <Route path="/Boutellis" element={<Boutellis />} />
          <Route path="/AeroLink" element={<AeroLink />} />
          <Route path="/AgroSmart" element={<AgroSmart />} />
          <Route path="/EduSmart" element={<EduSmart />} />
          <Route path="/EduFlex" element={<EduFlex />} />
          <Route path="/HACKATHON6.0" element={<HackAtlas />} />
          <Route path="/HackMinds" element={<HackMinds />} />
          <Route path="/HackEsprit" element={<HackEsprit />} />
          <Route path="/SinistrIA" element={<SinistrIA />} />
          <Route path="/Yopex" element={<Yopex />} />
          <Route path="/Khadamet" element={<Khadamet />} />
          <Route path="/RNEBot" element={<RNEBot />} />
          <Route path="/NeoTm" element={<NeoTm />} />
          <Route path="/VisioWave" element={<VisioWave />} />
          <Route path="/Massai" element={<Massai />} />
          <Route path="/IEEE" element={<IEEE />} />
          <Route path="/ExpressFM" element={<ExpressFM />} />
          <Route path="/RadioIFM" element={<RadioIFM />} />
          <Route path="/LinearRegression" element={<LinearRegression />} />
          <Route path="/Samsung" element={<Samsung />} />
          <Route path="/TuniHack" element={<TuniHack />} />
          <Route path="/SMUHack" element={<SMUHack />} />
          <Route path="/Hack4Justice" element={<Hack4Justice />} />
          <Route path="/HackFlow" element={<HackFlow />} />

      </Routes>
      <Footer/>
      <ScrollUp/>
    </BrowserRouter>
    </>
  );
}

export default App;
